import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const UrgencyIndicator = ({ level, daysRemaining }) => {
  const { t, isRTL } = useLanguage();

  const urgencyConfig = {
    critical: {
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      label: t('visas.critical')
    },
    high: {
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      label: t('visas.urgent')
    },
    medium: {
      icon: 'Clock',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      label: t('visas.medium')
    },
    low: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      label: t('visas.normal')
    }
  };

  const config = urgencyConfig?.[level] || urgencyConfig?.low;

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-md ${config?.bgColor}`}>
      <Icon name={config?.icon} size={16} className={config?.color} />
      <span className={`text-sm font-medium ${config?.color}`}>
        {config?.label}
      </span>
      {daysRemaining !== undefined && (
        <span className="text-xs text-muted-foreground ml-1">
          ({daysRemaining}{isRTL ? 'ي' : 'j'})
        </span>
      )}
    </div>
  );
};

export default UrgencyIndicator;